import React from 'react';
import { motion } from 'framer-motion';

function WhyMobikodeSection({ outcomesData = [] }) {
    if (!outcomesData || outcomesData.length === 0) return null;

    return (
        <section className="w-full bg-white pb-[40px] lg:pb-[50px]">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">

                {/* Header Block */}
                <div className="mb-[36px] lg:mb-[52px]">
                    <p className="font-graphik text-[14px] sm:text-[16px] font-[500] text-[#ED6800] tracking-wide mb-2.5">
                        Key Differentiators
                    </p>
                    <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] leading-[1.2] tracking-tight">
                        Why Mobikode?
                    </h2>
                </div>

                {/* 4-Column Card Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
                    {outcomesData.map((item, index) => {
                        const stepNum = String(index + 1).padStart(2, '0');

                        return (
                            <motion.div
                                key={item.id || index}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.45, delay: index * 0.08 }}
                                className="relative bg-white border border-[#D9E2EC] p-7 sm:p-8 min-h-[220px] lg:min-h-[250px] flex flex-col justify-between overflow-hidden group transition-all duration-300"
                            >
                                <div className="flex items-center justify-between w-full">
                                    <div className="w-[32px] h-[3px] bg-[#ED6800]" />
                                    <span className="font-sora text-[20px] sm:text-[30px] font-[600] text-[#01386A]/20 group-hover:text-[#01386A]/40 transition-colors duration-300">
                                        {stepNum}
                                    </span>
                                </div>

                                {/* Content */}
                                <div className="mt-8 relative z-10">
                                    <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora leading-[1.35] tracking-tight">
                                        {item.text}
                                    </h3>
                                </div>

                                {/* Bottom Border Accent (Navy to Orange on hover) */}
                                <div className="absolute bottom-0 left-0 w-full h-[3px] bg-[#01386A]/15" />
                                <div className="absolute bottom-0 left-0 h-[3px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full" />
                            </motion.div>
                        );
                    })}
                </div>

            </div>
        </section>
    );
}

export default WhyMobikodeSection;